import { Button as AntdButton } from 'antd';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  gap: 20px;
`;

export const Description = styled.p`
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  width: 90%;
  margin: 0;
`;

export const ActionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const ConfirmButton = styled(AntdButton)`
  width: 100%;
  height: 40px;
  border-radius: 4px;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  cursor: pointer;
`;
